import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import membersService from "./membersService";
import { fetchNetworks } from "../n2nActivation/n2nSlice";

interface membersSlice {
  fetchNonMembersList: {
    fetchNonMembersListData: any;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
    totalCount: number;
  };

  fetchNetworksList: {
    fetchNetworksListData: any;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
    totalCount: number;
  };

  fetchSAPNetworksList: {
    fetchSAPNetworksListData: any;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
    totalCount: number;
  };

  fetchSAPDeactivatedNetworksList: {
    fetchSAPDeactivatedNetworksListData: any;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
    totalCount: number;
  };
  fetchLocation: {
    fetchLocationData: any;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };

  fetchSite: {
    fetchSiteData: any;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };

  fetchMembersList: {
    fetchMembersListData: any;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
    totalCount: number;
  };

  fetchDeletedMembersList: {
    fetchDeletedMembersListData: any;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
    totalCount: number;
  };

  deleteMembers: {
    deleteMembersListData: any;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
    totalCount: number;
  };

  deleteBusinessAccountList: {
    deleteBusinessAccountListData: any;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
    totalCount: number;
  };

  fetchAttributeValues: {
    fetchAttributeValuesData: any;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
    totalCount: number;
  };

  fetchDeactivatedNetworksList: {
    fetchDeactivatedNetworksListData: any[]; // or proper type instead of any
    isLoading: boolean;
    isError: boolean;
    message: string;
    totalCount: number;
  };


  fetchViewNetworksList: {
    fetchViewNetworksListData: any[]; // or proper type instead of any
    isLoading: boolean;
    isSuccess: boolean;
    isError: boolean;
    message: string;
    totalCount: number;
  };

  fetchSystemMetricsList: {
    fetchSystemMetricsListData: any; // or proper type instead of any
    isLoading: boolean;
    isError: boolean;
    message: string;
    totalCount: number;
  };

  fetchDBMetricsList: {
    fetchDBMetricsListData: any; // or proper type instead of any
    isLoading: boolean;
    isError: boolean;
    message: string;
    totalCount: number;
  };

  fetchBusinessAccountList: {
    fetchBusinessAccountListData: any; // or proper type instead of any
    isLoading: boolean;
    isError: boolean;
    message: string;
    totalCount: number;
  };

  fetchViewDeactivatedNetworksList: {
    fetchViewDeactivatedNetworksListData: any[]; // or proper type instead of any
    isLoading: boolean;
    isError: boolean;
    message: string;
    totalCount: number;
  };

  fetchUserDetails: {
    fetchUserDetailsData: any;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };


  fetchDeletedBusinessAccountList: {
    fetchDeletedBusinessAccountListData: any;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };


  multiFunctionDeleteUsers: {
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };
  uploadFile: {
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };
  addUser: {
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };
  editUser: {
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };

  fetchUserAddedDetails: {
    userAddedData: any;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };
  updateUserDetails: {
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };
  fetchCountry: {
    countryList: any;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };
  updatePublicHoliday: {
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };
  addDayoffAvoid: {
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };
  removeDayoffAvoid: {
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };
  fetchRoleBasedSpeciality: {
    roleBasedSpecialityData: any;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };
  fetchScheduleList: {
    scheduleListData: any;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };
  createLeave: {
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };
  fetchLeaveDetails: {
    leaveDetailsData: any;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };
  updateLeaveDetails: {
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };
  removeLeave: {
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };
  validateLeave: {
    validateLeaveData: any;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };

  saveNotes: {
    saveNotesData: any;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };

  editNotes: {
    isLoading: boolean;
    isSuccess: boolean;
    isError: boolean;
    message: string;
  };

  deleteNotes: {
    isLoading: boolean;
    isSuccess: boolean;
    isError: boolean;
    message: string;
  };
  fetchNotesList: {
    fetchNotesListData: [],
    isLoading: boolean,
    isError: boolean,
    isSuccess: boolean,
    message: "",
  };
}

const initialState: membersSlice = {
  fetchNonMembersList: {
    fetchNonMembersListData: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
    totalCount: 0,
  },

  fetchNetworksList: {
    fetchNetworksListData: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
    totalCount: 0,
  },
  fetchSAPNetworksList: {
    fetchSAPNetworksListData: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
    totalCount: 0,
  },


  fetchSAPDeactivatedNetworksList: {
    fetchSAPDeactivatedNetworksListData: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
    totalCount: 0,
  },


  fetchMembersList: {
    fetchMembersListData: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
    totalCount: 0,
  },

  fetchDeletedMembersList: {
    fetchDeletedMembersListData: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
    totalCount: 0,
  },
  fetchDeactivatedNetworksList: {
    fetchDeactivatedNetworksListData: [],
    isLoading: false,
    isError: false,
    message: "",
    totalCount: 0,
  },

  fetchSystemMetricsList: {
    fetchSystemMetricsListData: [],
    isLoading: false,
    isError: false,
    message: "",
    totalCount: 0,
  },


  fetchDBMetricsList: {
    fetchDBMetricsListData: [],
    isLoading: false,
    isError: false,
    message: "",
    totalCount: 0,
  },

  fetchBusinessAccountList: {
    fetchBusinessAccountListData: [],
    isLoading: false,
    isError: false,
    message: "",
    totalCount: 0,
  },

  fetchDeletedBusinessAccountList: {
    fetchDeletedBusinessAccountListData: [],
    isLoading: false,
    isSuccess: false,
    isError: false,
    message: "",
  },


  fetchViewDeactivatedNetworksList: {
    fetchViewDeactivatedNetworksListData: [],
    isLoading: false,
    isError: false,
    message: "",
    totalCount: 0,
  },
  deleteMembers: {
    deleteMembersListData: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
    totalCount: 0,
  },

  deleteBusinessAccountList: {
    deleteBusinessAccountListData: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
    totalCount: 0,
  },


  fetchAttributeValues: {
    fetchAttributeValuesData: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
    totalCount: 0,
  },

  fetchViewNetworksList: {
    fetchViewNetworksListData: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
    totalCount: 0,
  },
  fetchUserDetails: {
    fetchUserDetailsData: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  multiFunctionDeleteUsers: {
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  uploadFile: {
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },

  addUser: {
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  editUser: {
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  fetchUserAddedDetails: {
    userAddedData: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  updateUserDetails: {
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  fetchCountry: {
    countryList: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  updatePublicHoliday: {
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  addDayoffAvoid: {
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  removeDayoffAvoid: {
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  fetchRoleBasedSpeciality: {
    roleBasedSpecialityData: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  fetchScheduleList: {
    scheduleListData: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  createLeave: {
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  fetchLeaveDetails: {
    leaveDetailsData: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  updateLeaveDetails: {
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  removeLeave: {
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  validateLeave: {
    validateLeaveData: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  fetchLocation: {
    fetchLocationData: false,
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  fetchSite: {
    fetchSiteData: false,
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },

  saveNotes: {
    saveNotesData: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },

  editNotes: {
    isLoading: false,
    isSuccess: false,
    isError: false,
    message: "",
  },

  deleteNotes: {
    isLoading: false,
    isSuccess: false,
    isError: false,
    message: "",
  },

  fetchNotesList: {
    fetchNotesListData: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
};

//action to fetch  user list and searching user
export const fetchNonMembersList = createAsyncThunk(
  "users/fetchNonMembersList",
  async (
    {
      searchquery,
      pageNumber,
      alphabet,
      groupId,
      hospitalId,
      isActive,
      specialityId,
    }: {
      searchquery?: any;
      pageNumber?: any;
      alphabet?: string;
      groupId?: string;
      hospitalId?: string;
      isActive?: boolean;
      specialityId?: string;
    },
    thunkAPI
  ) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state.auth.user.token;

      // ✅ fallback to empty string if undefined or null
      const query = searchquery ?? "";

      const response = await membersService.fetchNonMembersListData(
        {
          searchquery: query,
          pageNumber,
          alphabet,
          groupId,
          hospitalId,
          isActive,
          specialityId,
        },
        token
      );

      if (response.isSuccess) {
        const formattedData = {
          total_count: response?.result?.total_count,
          result: response?.result?.data,
        };
        return { ...response, result: formattedData };
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const fetchMembersList = createAsyncThunk(
  "users/fetchMembersList",
  async (
    {
      searchquery,
      pageNumber,
      alphabet,
      groupId,
      hospitalId,
      isActive,
      specialityId,
    }: {
      searchquery?: any;
      pageNumber?: any;
      alphabet?: string;
      groupId?: string;
      hospitalId?: string;
      isActive?: boolean;
      specialityId?: string;
    },
    thunkAPI
  ) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state.auth.user.token;

      const response = await membersService.fetchMembersListData(
        {
          searchquery: searchquery ?? "",   // ✅ only this changed
          pageNumber,
          alphabet,
          groupId,
          hospitalId,
          isActive,
          specialityId
        },
        token
      );

      if (response.isSuccess) {
        const formattedData = {
          total_count: response?.result?.total_count,
          result: response?.result?.data,
        };
        return { ...response, result: formattedData };
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const fetchDeletedMembersList = createAsyncThunk(
  "users/fetchDeletedMembersList",
  async (
    {
      searchquery,
      pageNumber,
      alphabet,
      groupId,
      hospitalId,
      isActive,
      specialityId,
    }: {
      searchquery?: any;
      pageNumber?: any;
      alphabet?: string;
      groupId?: string;
      hospitalId?: string;
      isActive?: boolean;
      specialityId?: string;
    },
    thunkAPI
  ) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state.auth.user.token;

      // ✅ fallback for searchquery
      const query = searchquery ?? "";

      const response = await membersService.fetchDeletedMembersListData(
        { searchquery: query, pageNumber, alphabet, groupId, hospitalId, isActive, specialityId },
        token
      );

      if (response.isSuccess) {
        const formattedData = {
          total_count: response?.result?.total_count,
          result: response?.result?.data,
        };
        return { ...response, result: formattedData };
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const filterMembers = createAsyncThunk("members/filterMembers", async (userPayload: any, thunkAPI) => {
  try {
    const state = thunkAPI.getState() as RootState;
    const token = state.auth.user.token;

    const response = await membersService.filterMembers(userPayload, token);
    if (response.isSuccess) {
      return response;
    } else {
      throw new Error(response.message);
    }
  } catch (error: any) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const fetchDeactivatedNetworksList = createAsyncThunk(
  "users/fetchDeactivatedNetworksList",
  async (
    {
      searchquery,
      pageNumber,
      alphabet,
      groupId,
      hospitalId,
      isActive,
      specialityId,
    }: {
      searchquery?: any;
      pageNumber?: any;
      alphabet?: string;
      groupId?: string;
      hospitalId?: string;
      isActive?: boolean;
      specialityId?: string;
    },
    thunkAPI
  ) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state.auth.user.token;

      const response = await membersService.fetchDeactivatedNetworksList(
        {
          searchquery: searchquery ?? "",   // ✅ only this changed
          pageNumber,
          alphabet,
          groupId,
          hospitalId,
          isActive,
          specialityId
        },
        token
      );

      if (response.isSuccess) {
        const formattedData = {
          total_count: response?.result?.total_count,
          result: response?.result,
        };
        return { ...response, result: formattedData };
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);


export const fetchBusinessAccountList = createAsyncThunk(
  "users/fetchBusinessAccountList",
  async (
    {
      searchquery,
      pageNumber,
      alphabet,
      groupId,
      hospitalId,
      isActive,
      specialityId,
    }: {
      searchquery?: any;
      pageNumber?: any;
      alphabet?: string;
      groupId?: string;
      hospitalId?: string;
      isActive?: boolean;
      specialityId?: string;
    },
    thunkAPI
  ) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state.auth.user.token;

      const response = await membersService.fetchBusinessAccountList(
        {
          searchquery: searchquery ?? "",   // ✅ only this changed
          pageNumber,
          alphabet,
          groupId,
          hospitalId,
          isActive,
          specialityId
        },
        token
      );

      if (response.isSuccess) {
        console.log(response.result, "response123 ✅ actual data");
        return response;  // ✅ don't rewrap result
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);


export const updateBusinessAccountList = createAsyncThunk(
  "membershipManagement/updateBusinessAccountList",
  async (payload: any, thunkAPI) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state.superAdminAuth?.superAdminUser?.access_token;

      const response = await await membersService.updateBusinessAccountList(
        payload,
        token
      );
      if (response.isSuccess) {
        return response;
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteBusinessAccountList = createAsyncThunk(
  "membershipManagement/deleteBusinessAccountList",
  async (payload: any, thunkAPI) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state.superAdminAuth?.superAdminUser?.access_token;

      const response = await membersService.deleteBusinessAccountList(
        payload,
        token
      );
      if (response.isSuccess) {
        return response;
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);


export const fetchDeletedBusinessAccountList = createAsyncThunk(
  "membershipManagement/getDeletedBusinessAccountList",
  async (payload: any, thunkAPI) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state.superAdminAuth?.superAdminUser?.access_token;

      const response = await membersService.fetchDeletedBusinessAccountList(
        payload,
        token
      );
      if (response.isSuccess) {
        return response;
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const validateLogin = createAsyncThunk(
  "users/validateLogin",
  async ({ username, password }: { username: string; password: string }, thunkAPI) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state.auth.user.token;

      const response = await membersService.validateLogin({ username, password }, token);

      if (response.isSuccess) {
        return response;
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);


export const makePayment = createAsyncThunk(
  "users/makePayment",
  async ({ amount, currency, product_name, network_details, plan_id }: { amount: any; currency: string, product_name: string, network_details?: Object, plan_id: any }, thunkAPI) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state.auth.user.token;

      const response = await membersService.makePayment({ amount, currency, product_name, network_details, plan_id }, token);

      if (response.isSuccess) {
        return response;
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteMembers = createAsyncThunk("members/deleteMembers", async (payload: any, thunkAPI) => {
  try {
    const state = thunkAPI.getState() as RootState;
    const token = state.auth.user.token;

    const response = await membersService.deleteMembers(payload, token);

    if (response.isSuccess) {
      return response;
    } else {
      throw new Error(response.message);
    }
  } catch (error: any) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});


// export const deleteBusinessAccountList = createAsyncThunk("members/deleteBusinessAccountList", async (payload: any, thunkAPI) => {
//   try {
//     const state = thunkAPI.getState() as RootState;
//     const token = state.auth.user.token;

//     const response = await membersService.deleteBusinessAccountList(payload, token);

//     if (response.isSuccess) {
//       return response;
//     } else {
//       throw new Error(response.message);
//     }
//   } catch (error: any) {
//     const message =
//       (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
//     return thunkAPI.rejectWithValue(message);
//   }
// });

export const deactivateMembers = createAsyncThunk("members/deactivateMembers", async (payload: any, thunkAPI) => {
  try {
    const state = thunkAPI.getState() as RootState;
    const token = state.auth.user.token;

    const response = await membersService.deactivateMembers(payload, token);

    if (response.isSuccess) {
      return response;
    } else {
      throw new Error(response.message);
    }
  } catch (error: any) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const updateBusinessAccountDetails = createAsyncThunk("members/updateBusinessAccountDetails", async (payload: any, thunkAPI) => {
  try {
    const state = thunkAPI.getState() as RootState;
    const token = state.auth.user.token;

    const response = await membersService.updateBusinessAccountDetails(payload, token);

    if (response.isSuccess) {
      return response;
    } else {
      throw new Error(response.message);
    }
  } catch (error: any) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});


export const activateMembers = createAsyncThunk("members/activateMembers", async (payload: any, thunkAPI) => {
  try {
    const state = thunkAPI.getState() as RootState;
    const token = state.auth.user.token;

    const response = await membersService.activateMembers(payload, token);

    if (response.isSuccess) {
      return response;
    } else {
      throw new Error(response.message);
    }
  } catch (error: any) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const fetchLocations = createAsyncThunk(
  "users/fetchLocations",
  async (
    {
      searchquery,
      pageNumber,
      alphabet,
      groupId,
      hospitalId,
      isActive,
      specialityId,
    }: {
      searchquery?: any;
      pageNumber?: any;
      alphabet?: string;
      groupId?: string;
      hospitalId?: string;
      isActive?: boolean;
      specialityId?: string;
    },
    thunkAPI
  ) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state.auth.user.token;
      const response = await membersService.fetchLocations(
        { searchquery, pageNumber, alphabet, groupId, hospitalId, isActive, specialityId },
        token
      );
      if (response.isSuccess) {
        console.log("slice", response);

        return response;
        // return formattedData;
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const fetchSites = createAsyncThunk(
  "users/fetchSites",
  async (
    {
      searchquery,
      pageNumber,
      alphabet,
      groupId,
      hospitalId,
      isActive,
      specialityId,
    }: {
      searchquery?: any;
      pageNumber?: any;
      alphabet?: string;
      groupId?: string;
      hospitalId?: string;
      isActive?: boolean;
      specialityId?: string;
    },
    thunkAPI
  ) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state.auth.user.token;
      const response = await membersService.fetchSites(
        { searchquery, pageNumber, alphabet, groupId, hospitalId, isActive, specialityId },
        token
      );
      if (response.isSuccess) {
        console.log("slice", response);

        return response;
        // return response;
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const fetchDynamicNetworksList = createAsyncThunk(
  "users/fetchDynamicNetworksList",
  async (
    {
      searchquery,
      pageNumber,
      alphabet,
      groupId,
      hospitalId,
      isActive,
      specialityId,
    }: {
      searchquery?: any;
      pageNumber?: any;
      alphabet?: string;
      groupId?: string;
      hospitalId?: string;
      isActive?: boolean;
      specialityId?: string;
    },
    thunkAPI
  ) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state.auth.user.token;

      const query = searchquery ?? "";

      const response = await membersService.fetchDynamicNetworksList(
        {
          searchquery: query,
          pageNumber,
          alphabet,
          groupId,
          hospitalId,
          isActive,
          specialityId,
        },
        token
      );

      if (response.isSuccess) {
        const formattedData = {
          total_count: response?.result?.total_count,
          result: response?.result,
        };
        return { ...response, result: formattedData };
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response?.data?.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const fetchSAPDynamicNetworksList = createAsyncThunk(
  "users/fetchSAPDynamicNetworksList",
  async (
    {
      searchquery,
      pageNumber,
      alphabet,
      groupId,
      hospitalId,
      isActive,
      specialityId,
    }: {
      searchquery?: any;
      pageNumber?: any;
      alphabet?: string;
      groupId?: string;
      hospitalId?: string;
      isActive?: boolean;
      specialityId?: string;
    },
    thunkAPI
  ) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state.auth.user.token;

      const query = searchquery ?? "";

      const response = await membersService.fetchSAPDynamicNetworksList(
        {
          searchquery: query,
          pageNumber,
          alphabet,
          groupId,
          hospitalId,
          isActive,
          specialityId,
        },
        token
      );

      if (response.isSuccess) {
        const formattedData = {
          total_count: response?.result?.total_count,
          result: response?.result,
        };
        return { ...response, result: formattedData };
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response?.data?.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const fetchViewNetworksList = createAsyncThunk(
  "users/fetchViewNetworksList",
  async (
    {
      searchquery,
      pageNumber,
      alphabet,
      groupId,
      hospitalId,
      isActive,
      specialityId,
    }: {
      searchquery?: any;
      pageNumber?: any;
      alphabet?: string;
      groupId?: string;
      hospitalId?: string;
      isActive?: boolean;
      specialityId?: string;
    },
    thunkAPI
  ) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state.auth.user.token;

      const query = searchquery ?? "";

      const response = await membersService.fetchViewNetworksList(
        {
          searchquery: query,
          pageNumber,
          alphabet,
          groupId,
          hospitalId,
          isActive,
          specialityId,
        },
        token
      );

      if (response.isSuccess) {
        const formattedData = {
          total_count: response?.result?.total_count,
          result: response?.result,
        };
        return { ...response, result: formattedData };
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response?.data?.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const saveNotes = createAsyncThunk(
  "users/saveNotes",
  async (payload: any, thunkAPI) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state.auth.user.token;

      const response = await membersService.saveNotes(payload, token);
      if (response.isSuccess) {
        return response;
      } else {
        return thunkAPI.rejectWithValue({ message: response.message, result: response.result });
      }
    } catch (error: any) {
      const message =
        (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);


export const fetchNotesList = createAsyncThunk(
  "users/fetchNotesList",
  async (
    {
      id
    }: {
      id: string
    },
    thunkAPI
  ) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state.auth.user.token;
      const response = await membersService.fetchNotesListData(
        { id },
        token
      );
      if (response.isSuccess) {
        return response;

        // return formattedData;
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);



export const fetchSystemMetricsList = createAsyncThunk(
  "users/fetchSystemMetricsList",
  async (
    {
      searchquery,
      pageNumber,
      alphabet,
      groupId,
      hospitalId,
      isActive,
      specialityId,
    }: {
      searchquery?: any;
      pageNumber?: any;
      alphabet?: string;
      groupId?: string;
      hospitalId?: string;
      isActive?: boolean;
      specialityId?: string;
    },
    thunkAPI
  ) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state.auth.user.token;

      const query = searchquery ?? "";

      const response = await membersService.fetchSystemMetricsList(
        {
          searchquery: query,
          pageNumber,
          alphabet,
          groupId,
          hospitalId,
          isActive,
          specialityId,
        },
        token
      );

      if (response.isSuccess) {
        const formattedData = {
          total_count: response?.result?.total_count,
          result: response?.result,
        };
        return { ...response, result: formattedData };
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response?.data?.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const fetchDBMetricsList = createAsyncThunk(
  "users/fetchDBMetricsList",
  async (
    {
      searchquery,
      pageNumber,
      alphabet,
      groupId,
      hospitalId,
      isActive,
      specialityId,
    }: {
      searchquery?: any;
      pageNumber?: any;
      alphabet?: string;
      groupId?: string;
      hospitalId?: string;
      isActive?: boolean;
      specialityId?: string;
    },
    thunkAPI
  ) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state.auth.user.token;

      const query = searchquery ?? "";

      const response = await membersService.fetchDBMetricsList(
        {
          searchquery: query,
          pageNumber,
          alphabet,
          groupId,
          hospitalId,
          isActive,
          specialityId,
        },
        token
      );

      if (response.isSuccess) {
        const formattedData = {
          total_count: response?.result?.total_count,
          result: response?.result,
        };
        return { ...response, result: formattedData };
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response?.data?.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);



export const fetchSAPDeactivatedNetworksList = createAsyncThunk(
  "users/fetchSAPDeactivatedNetworksList",
  async (
    {
      searchquery,
      pageNumber,
      alphabet,
      groupId,
      hospitalId,
      isActive,
      specialityId,
    }: {
      searchquery?: any;
      pageNumber?: any;
      alphabet?: string;
      groupId?: string;
      hospitalId?: string;
      isActive?: boolean;
      specialityId?: string;
    },
    thunkAPI
  ) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state.auth.user.token;

      const query = searchquery ?? "";

      const response = await membersService.fetchSAPDeactivatedNetworksList(
        {
          searchquery: query,
          pageNumber,
          alphabet,
          groupId,
          hospitalId,
          isActive,
          specialityId,
        },
        token
      );

      if (response.isSuccess) {
        const formattedData = {
          total_count: response?.result?.total_count,
          result: response?.result,
        };
        console.log(response, "response")
        return { ...response, result: formattedData };
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response?.data?.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const fetchViewDynamicNetworksList = createAsyncThunk(
  "users/fetchViewDynamicNetworksList",
  async (
    {
      searchquery,
      pageNumber,
      alphabet,
      groupId,
      hospitalId,
      isActive,
      specialityId,
    }: {
      searchquery?: any;
      pageNumber?: any;
      alphabet?: string;
      groupId?: string;
      hospitalId?: string;
      isActive?: boolean;
      specialityId?: string;
    },
    thunkAPI
  ) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state.auth.user.token;

      const query = searchquery ?? "";

      const response = await membersService.fetchViewDynamicNetworksList(
        {
          searchquery: query,
          pageNumber,
          alphabet,
          groupId,
          hospitalId,
          isActive,
          specialityId,
        },
        token
      );

      if (response.isSuccess) {
        const formattedData = {
          total_count: response?.result?.total_count,
          result: response?.result,
        };
        return { ...response, result: formattedData };
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response?.data?.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const editNotes = createAsyncThunk(
  "members/editNotes",
  async (
    { id, note }: { id: any; note: string },
    thunkAPI
  ) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state.auth.user.token;

      const response = await membersService.editNotes(
        { id, note },
        token
      );

      if (response.isSuccess) {
        return response;
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        error.response?.data?.message ||
        error.message ||
        error.toString();

      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteNotes = createAsyncThunk(
  "member/deleteNotes",
  async (payload: any, thunkAPI) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state.auth.user.token;

      const response = await membersService.deleteNotes(payload, token);
      if (response.isSuccess) {
        return response;
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);


//users slice
const membersSlice = createSlice({
  name: "members",
  initialState,
  reducers: {
    // renamed to avoid thunk/reducer name collision
    resetFetchNonMembersList: (state) => {
      state.fetchNonMembersList = initialState.fetchNonMembersList;
    },
    resetFetchMembersList: (state) => {
      state.fetchMembersList = initialState.fetchMembersList;
    },
    resetFetchDeletedMembersList: (state) => {
      state.fetchDeletedMembersList = initialState.fetchDeletedMembersList;
    },
    resetFetchDynamicNetworksList: (state) => {
      state.fetchNetworksList = initialState.fetchNetworksList;
    },
    resetFetchSAPDynamicNetworksList: (state) => {
      state.fetchSAPNetworksList = initialState.fetchSAPNetworksList;
    },
    resetDeleteMembers: (state) => {
      state.deleteMembers = initialState.deleteMembers;
    },
    resetFetchUserDetails: (state) => {
      state.fetchUserDetails = initialState.fetchUserDetails;
    },
    resetMultiFunctionDeleteUsers: (state) => {
      state.multiFunctionDeleteUsers = initialState.multiFunctionDeleteUsers;
    },
    resetuploadFile: (state) => {
      state.uploadFile = initialState.uploadFile;
    },
    resetFetchAttributeValues: (state) => {
      state.fetchAttributeValues = initialState.fetchAttributeValues;
    },
    resetAddUser: (state) => {
      state.addUser = initialState.addUser;
    },
    resetEditUser: (state) => {
      state.editUser = initialState.editUser;
    },
    resetFetchUserAddedDetails: (state) => {
      state.fetchUserAddedDetails = initialState.fetchUserAddedDetails;
    },
    resetUpdateUserDetails: (state) => {
      state.updateUserDetails = initialState.updateUserDetails;
    },
    resetFetchCountry: (state) => {
      state.fetchCountry = initialState.fetchCountry;
    },
    resetUpdatePublicHoliday: (state) => {
      state.updatePublicHoliday = initialState.updatePublicHoliday;
    },
    resetAddDayoffAvoid: (state) => {
      state.addDayoffAvoid = initialState.addDayoffAvoid;
    },
    resetRemoveDayoffAvoid: (state) => {
      state.removeDayoffAvoid = initialState.removeDayoffAvoid;
    },
    resetFetchRoleBasedSpeciality: (state) => {
      state.fetchRoleBasedSpeciality = initialState.fetchRoleBasedSpeciality;
    },
    resetFetchScheduleList: (state) => {
      state.fetchScheduleList = initialState.fetchScheduleList;
    },
    resetCreateLeave: (state) => {
      state.createLeave = initialState.createLeave;
    },
    resetFetchLeaveDetails: (state) => {
      state.fetchLeaveDetails = initialState.fetchLeaveDetails;
    },
    resetUpdateLeaveDetails: (state) => {
      state.updateLeaveDetails = initialState.updateLeaveDetails;
    },
    resetRemoveLeave: (state) => {
      state.removeLeave = initialState.removeLeave;
    },
    resetValidateLeave: (state) => {
      state.validateLeave = initialState.validateLeave;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNonMembersList.pending, (state, action: PayloadAction<any>) => {
        state.fetchNonMembersList.isLoading = true;
      })
      .addCase(fetchNonMembersList.fulfilled, (state, action: PayloadAction<any>) => {
        state.fetchNonMembersList.isLoading = false;
        state.fetchNonMembersList.isSuccess = true;
        state.fetchNonMembersList.totalCount = action.payload.result.total_count;
        state.fetchNonMembersList.fetchNonMembersListData = action.payload.result.result;
      })
      .addCase(fetchNonMembersList.rejected, (state, action: PayloadAction<any>) => {
        state.fetchNonMembersList.isLoading = false;
        state.fetchNonMembersList.isError = true;
        state.fetchNonMembersList.message = action.payload;
      })

      .addCase(fetchDynamicNetworksList.pending, (state) => {
        state.fetchNetworksList.isLoading = true;
      })
      .addCase(fetchDynamicNetworksList.fulfilled, (state, action: PayloadAction<any>) => {
        state.fetchNetworksList.isLoading = false;
        state.fetchNetworksList.isSuccess = true;
        state.fetchNetworksList.totalCount = action.payload.result.total_count;
        state.fetchNetworksList.fetchNetworksListData = action.payload.result.result;
      })
      .addCase(fetchDynamicNetworksList.rejected, (state, action: PayloadAction<any>) => {
        state.fetchNetworksList.isLoading = false;
        state.fetchNetworksList.isError = true;
        state.fetchNetworksList.message = action.payload;
      })

      .addCase(fetchSAPDynamicNetworksList.pending, (state) => {
        state.fetchSAPNetworksList.isLoading = true;
      })
      .addCase(fetchSAPDynamicNetworksList.fulfilled, (state, action: PayloadAction<any>) => {
        state.fetchSAPNetworksList.isLoading = false;
        state.fetchSAPNetworksList.isSuccess = true;
        state.fetchSAPNetworksList.totalCount = action.payload.result.total_count;
        state.fetchSAPNetworksList.fetchSAPNetworksListData = action.payload.result.result;
      })
      .addCase(fetchSAPDynamicNetworksList.rejected, (state, action: PayloadAction<any>) => {
        state.fetchSAPNetworksList.isLoading = false;
        state.fetchSAPNetworksList.isError = true;
        state.fetchSAPNetworksList.message = action.payload;
      })

      .addCase(fetchDeactivatedNetworksList.pending, (state) => {
        state.fetchDeactivatedNetworksList.isLoading = true;
      })
      .addCase(fetchDeactivatedNetworksList.fulfilled, (state, action: PayloadAction<any>) => {
        state.fetchDeactivatedNetworksList.isLoading = false;
        state.fetchDeactivatedNetworksList.fetchDeactivatedNetworksListData = action.payload?.result?.result // adjust based on API response
        state.fetchDeactivatedNetworksList.totalCount =
          action.payload?.result?.total_count || 0;
      })
      .addCase(fetchDeactivatedNetworksList.rejected, (state, action: PayloadAction<any>) => {
        state.fetchDeactivatedNetworksList.isLoading = false;
        state.fetchDeactivatedNetworksList.isError = true;
        state.fetchDeactivatedNetworksList.message = action.payload as string;
      })

      .addCase(fetchViewNetworksList.pending, (state) => {
        state.fetchViewNetworksList.isLoading = true;
      })
      .addCase(fetchViewNetworksList.fulfilled, (state, action: PayloadAction<any>) => {
        state.fetchViewNetworksList.isLoading = false;
        state.fetchViewNetworksList.fetchViewNetworksListData = action.payload?.result?.result // adjust based on API response
        state.fetchViewNetworksList.totalCount =
          action.payload?.result?.total_count || 0;
      })
      .addCase(fetchViewNetworksList.rejected, (state, action: PayloadAction<any>) => {
        state.fetchViewNetworksList.isLoading = false;
        state.fetchViewNetworksList.isError = true;
        state.fetchViewNetworksList.message = action.payload as string;
      })
      .addCase(fetchSAPDeactivatedNetworksList.pending, (state) => {
        state.fetchSAPDeactivatedNetworksList.isLoading = true;
      })
      .addCase(fetchSAPDeactivatedNetworksList.fulfilled, (state, action: PayloadAction<any>) => {
        state.fetchSAPDeactivatedNetworksList.isLoading = false;
        state.fetchSAPDeactivatedNetworksList.fetchSAPDeactivatedNetworksListData = action.payload?.result?.result // adjust based on API response
        state.fetchSAPDeactivatedNetworksList.totalCount =
          action.payload?.result?.total_count || 0;
      })
      .addCase(fetchSAPDeactivatedNetworksList.rejected, (state, action: PayloadAction<any>) => {
        state.fetchSAPDeactivatedNetworksList.isLoading = false;
        state.fetchSAPDeactivatedNetworksList.isError = true;
        state.fetchSAPDeactivatedNetworksList.message = action.payload as string;
      })


      .addCase(fetchSystemMetricsList.pending, (state) => {
        state.fetchSystemMetricsList.isLoading = true;
      })
      .addCase(fetchSystemMetricsList.fulfilled, (state, action: PayloadAction<any>) => {
        state.fetchSystemMetricsList.isLoading = false;
        state.fetchSystemMetricsList.fetchSystemMetricsListData = action.payload?.result?.result // adjust based on API response
        state.fetchSystemMetricsList.totalCount =
          action.payload?.result?.total_count || 0;
      })
      .addCase(fetchSystemMetricsList.rejected, (state, action: PayloadAction<any>) => {
        state.fetchSystemMetricsList.isLoading = false;
        state.fetchSystemMetricsList.isError = true;
        state.fetchSystemMetricsList.message = action.payload as string;
      })



      .addCase(fetchDBMetricsList.pending, (state) => {
        state.fetchDBMetricsList.isLoading = true;
      })
      .addCase(fetchDBMetricsList.fulfilled, (state, action: PayloadAction<any>) => {
        state.fetchDBMetricsList.isLoading = false;
        state.fetchDBMetricsList.fetchDBMetricsListData = action.payload?.result?.result // adjust based on API response
        state.fetchDBMetricsList.totalCount =
          action.payload?.result?.total_count || 0;
      })
      .addCase(fetchDBMetricsList.rejected, (state, action: PayloadAction<any>) => {
        state.fetchDBMetricsList.isLoading = false;
        state.fetchDBMetricsList.isError = true;
        state.fetchDBMetricsList.message = action.payload as string;
      })
      .addCase(fetchBusinessAccountList.pending, (state) => {
        state.fetchBusinessAccountList.isLoading = true;
      })
      .addCase(fetchBusinessAccountList.fulfilled, (state, action: PayloadAction<any>) => {
        state.fetchBusinessAccountList.isLoading = false;
        state.fetchBusinessAccountList.fetchBusinessAccountListData = action.payload?.result // adjust based on API response
        state.fetchBusinessAccountList.totalCount =
          action.payload?.result?.total_count || 0;
      })
      .addCase(fetchBusinessAccountList.rejected, (state, action: PayloadAction<any>) => {
        state.fetchBusinessAccountList.isLoading = false;
        state.fetchBusinessAccountList.isError = true;
        state.fetchBusinessAccountList.message = action.payload as string;
      })

      .addCase(fetchNotesList.pending, (state, action: PayloadAction<any>) => {
        state.fetchNotesList.isLoading = true;
      })
      .addCase(fetchNotesList.fulfilled, (state, action: PayloadAction<any>) => {
        state.fetchNotesList.isLoading = false;
        state.fetchNotesList.isSuccess = true;
        state.fetchNotesList.message = action.payload.message;
        state.fetchNotesList.fetchNotesListData = action.payload.result;
      })
      .addCase(fetchNotesList.rejected, (state, action: PayloadAction<any>) => {
        state.fetchNotesList.isLoading = false;
        state.fetchNotesList.isError = true;
        state.fetchNotesList.message = action.payload;
      })


      .addCase(fetchViewDynamicNetworksList.pending, (state) => {
        state.fetchViewDeactivatedNetworksList.isLoading = true;
      })
      .addCase(fetchViewDynamicNetworksList.fulfilled, (state, action: PayloadAction<any>) => {
        state.fetchViewDeactivatedNetworksList.isLoading = false;
        state.fetchViewDeactivatedNetworksList.fetchViewDeactivatedNetworksListData = action.payload?.result?.result // adjust based on API response
        state.fetchViewDeactivatedNetworksList.totalCount =
          action.payload?.result?.total_count || 0;
      })
      .addCase(fetchViewDynamicNetworksList.rejected, (state, action: PayloadAction<any>) => {
        state.fetchViewDeactivatedNetworksList.isLoading = false;
        state.fetchViewDeactivatedNetworksList.isError = true;
        state.fetchViewDeactivatedNetworksList.message = action.payload as string;
      })
      .addCase(fetchMembersList.pending, (state, action: PayloadAction<any>) => {
        state.fetchMembersList.isLoading = true;
      })
      .addCase(fetchMembersList.fulfilled, (state, action: PayloadAction<any>) => {
        state.fetchMembersList.isLoading = false;
        state.fetchMembersList.isSuccess = true;
        state.fetchMembersList.totalCount = action.payload.result.total_count;
        state.fetchMembersList.fetchMembersListData = action.payload.result.result;
      })
      .addCase(fetchMembersList.rejected, (state, action: PayloadAction<any>) => {
        state.fetchMembersList.isLoading = false;
        state.fetchMembersList.isError = true;
        state.fetchMembersList.message = action.payload;
      })

      .addCase(fetchDeletedMembersList.pending, (state, action: PayloadAction<any>) => {
        state.fetchDeletedMembersList.isLoading = true;
      })
      .addCase(fetchDeletedMembersList.fulfilled, (state, action: PayloadAction<any>) => {
        state.fetchDeletedMembersList.isLoading = false;
        state.fetchDeletedMembersList.isSuccess = true;
        state.fetchDeletedMembersList.totalCount = action.payload.result.total_count;
        state.fetchDeletedMembersList.fetchDeletedMembersListData = action.payload.result.result;
      })
      .addCase(fetchDeletedMembersList.rejected, (state, action: PayloadAction<any>) => {
        state.fetchDeletedMembersList.isLoading = false;
        state.fetchDeletedMembersList.isError = true;
        state.fetchDeletedMembersList.message = action.payload;
      })

      .addCase(deleteMembers.pending, (state, action: PayloadAction<any>) => {
        state.deleteMembers.isLoading = true;
      })
      .addCase(deleteMembers.fulfilled, (state, action: PayloadAction<any>) => {
        state.deleteMembers.isLoading = false;
        state.deleteMembers.isSuccess = true;
        state.deleteMembers.totalCount = action.payload.result.total_count;
        state.deleteMembers.deleteMembersListData = action.payload.result.result;
      })
      .addCase(deleteMembers.rejected, (state, action: PayloadAction<any>) => {
        state.deleteMembers.isLoading = false;
        state.deleteMembers.isError = true;
        state.deleteMembers.message = action.payload;
      })

      .addCase(deleteBusinessAccountList.pending, (state, action: PayloadAction<any>) => {
        state.deleteBusinessAccountList.isLoading = true;
      })
      .addCase(deleteBusinessAccountList.fulfilled, (state, action: PayloadAction<any>) => {
        state.deleteBusinessAccountList.isLoading = false;
        state.deleteBusinessAccountList.isSuccess = true;
        state.deleteBusinessAccountList.totalCount = action.payload.result.total_count;
        state.deleteBusinessAccountList.deleteBusinessAccountListData = action.payload.result.result;
      })
      .addCase(deleteBusinessAccountList.rejected, (state, action: PayloadAction<any>) => {
        state.deleteBusinessAccountList.isLoading = false;
        state.deleteBusinessAccountList.isError = true;
        state.deleteBusinessAccountList.message = action.payload;
      })


      .addCase(fetchDeletedBusinessAccountList.pending, (state, action: PayloadAction<any>) => {
        state.fetchDeletedBusinessAccountList.isLoading = true;
      })
      .addCase(fetchDeletedBusinessAccountList.fulfilled, (state, action: PayloadAction<any>) => {
        state.fetchDeletedBusinessAccountList.isLoading = false;
        state.deleteBusinessAccountList.isSuccess = true;
        // state.fetchDeletedBusinessAccountList.totalCount = action.payload.result.total_count;
        state.fetchDeletedBusinessAccountList.fetchDeletedBusinessAccountListData = action.payload.result;
      })
      .addCase(fetchDeletedBusinessAccountList.rejected, (state, action: PayloadAction<any>) => {
        state.fetchDeletedBusinessAccountList.isLoading = false;
        state.fetchDeletedBusinessAccountList.isError = true;
        state.fetchDeletedBusinessAccountList.message = action.payload;
      })

      .addCase(editNotes.pending, (state, action: PayloadAction<any>) => {
        state.editNotes.isLoading = true;
      })
      .addCase(editNotes.fulfilled, (state, action: PayloadAction<any>) => {
        state.editNotes.isLoading = false;
        state.editNotes.isSuccess = true;
        state.editNotes.message = action.payload.message;
      })
      .addCase(editNotes.rejected, (state, action: PayloadAction<any>) => {
        state.editNotes.isLoading = false;
        state.editNotes.isError = true;
        state.editNotes.message = action.payload;
      })


      .addCase(deleteNotes.pending, (state, action: PayloadAction<any>) => {
        state.deleteNotes.isLoading = true;
      })
      .addCase(deleteNotes.fulfilled, (state, action: PayloadAction<any>) => {
        state.deleteNotes.isLoading = false;
        state.deleteNotes.isSuccess = true;
        state.deleteNotes.message = action.payload.message;
      })
      .addCase(deleteNotes.rejected, (state, action: PayloadAction<any>) => {
        state.deleteNotes.isLoading = false;
        state.deleteNotes.isError = true;
        state.deleteNotes.message = action.payload;
      })


      .addCase(fetchLocations.pending, (state, action: PayloadAction<any>) => {
        state.fetchLocation.isLoading = true;
      })
      .addCase(fetchLocations.fulfilled, (state, action: PayloadAction<any>) => {
        state.fetchLocation.isLoading = false;
        state.fetchLocation.isSuccess = true;
        state.fetchLocation.message = action.payload.message;
        state.fetchLocation.fetchLocationData = action.payload.result;
      })
      .addCase(fetchLocations.rejected, (state, action: PayloadAction<any>) => {
        state.fetchLocation.isLoading = false;
        state.fetchLocation.isError = true;
        state.fetchLocation.message = action.payload;
      })
      .addCase(fetchSites.pending, (state, action: PayloadAction<any>) => {
        state.fetchSite.isLoading = true;
      })
      .addCase(fetchSites.fulfilled, (state, action: PayloadAction<any>) => {
        state.fetchSite.isLoading = false;
        state.fetchSite.isSuccess = true;
        state.fetchSite.message = action.payload.message;
        state.fetchSite.fetchSiteData = action.payload.result;
      })
      .addCase(fetchSites.rejected, (state, action: PayloadAction<any>) => {
        state.fetchSite.isLoading = false;
        state.fetchSite.isError = true;
        state.fetchSite.message = action.payload;
      });



  },
});

export const {
  resetFetchNonMembersList,
  resetFetchMembersList,
  resetFetchDeletedMembersList,
  resetFetchDynamicNetworksList,
  resetDeleteMembers,
  resetFetchUserDetails,
  resetMultiFunctionDeleteUsers,
  resetAddUser,
  resetEditUser,
  resetFetchUserAddedDetails,
  resetUpdateUserDetails,
  resetFetchCountry,
  resetUpdatePublicHoliday,
  resetAddDayoffAvoid,
  resetRemoveDayoffAvoid,
  resetFetchRoleBasedSpeciality,
  resetFetchScheduleList,
  resetCreateLeave,
  resetFetchLeaveDetails,
  resetUpdateLeaveDetails,
  resetRemoveLeave,
  resetValidateLeave,
  resetFetchAttributeValues,
  resetuploadFile,
  // kept export list consistent; you can remove duplicate if undesired
} = membersSlice.actions;

export default membersSlice.reducer;